import { render, staticRenderFns } from "./ProjectMaterialsAndPrices.vue?vue&type=template&id=6468d8de&scoped=true&"
import script from "./ProjectMaterialsAndPrices.vue?vue&type=script&lang=js&"
export * from "./ProjectMaterialsAndPrices.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMaterialsAndPrices.vue?vue&type=style&index=0&id=6468d8de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6468d8de",
  null
  
)

export default component.exports